module.exports = __webpack_public_path__ + "img/instagram-icon.dbad94d0.svg";